import axios from "axios";
// import home from "../../home/home";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  logOut,
} from "../../../common/utils";
// import user from "../../../common/mookup/mokup_ListaUser";
import jwt_decode from "jwt-decode";

export default class dashboardPayroll {
  getDataCotrollori(onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios.get(host + "/api/v1/user/find/", configHeaders).then(
      function (result) {
        if (result.status === 401) {
          logOut();
        }
        let dataTableUtenti = [];
        // console.log(result.data)
        result.data.map((result) => {
          if (result.ruoliOperatori.nomeRuolo === "0") {
            dataTableUtenti = [
              ...dataTableUtenti,
              {
                numMatricola: result.numMatricola,
                ruolo: result.ruoliOperatori.nomeRuolo, //result.ruoliOperatori.nomeRuolo === "4" ? "Ruolo Da Definire" : result.ruoliOperatori.nomeRuolo === "5" ? "Ruolo Da definire 2"
                idAnagraficaOperatore: result.idAnagraficaOperatore,
              },
            ];
          }
        });
        // console.log(dataTableUtenti);
        onSuccess(dataTableUtenti);
      },
      function (error) {
        // if(error.response.status === 401){
        //   logOut();
        // }
        console.log("errore ricerca composizione " + error);
        // onSuccess(headerDataTableSanzione, user);
      }
    );
  }

  getDatiConrollore(nomeMatricola, dataInizio, dataFine, onSuccess) {
    var headerDataTableSanzione = [
      { label: "Stato", field: "stato", width: 270 },
      { label: "Num. Sanzione", field: "numSanzione", width: 270 },
      { label: "Data Payroll", field: "dataPayroll", width: 270 },
      { label: "Importo", field: "importo", width: 270 },
    ];
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/payroll/${nomeMatricola}/${dataInizio}/${dataFine}`,
        configHeaders
      )
      .then(
        function (result) {
          if (result.status === 401) {
            logOut();
          }
          let dataTableUtenti = [];
          result.data.map((val) => {
            dataTableUtenti = [
              ...dataTableUtenti,
              {
                idSanzione: val.idSanzione,
                numSanzione: val.numSanzione,
                importo: parseFloat(val.importo / 100)
                  .toFixed(2)
                  .toString()
                  .replace(".", ",") + "€",
                dataPayroll: geDataFormat(val.dataPayroll),
                stato: val.stato,
              },
            ];
          });
          onSuccess(headerDataTableSanzione, dataTableUtenti, result.data);
        },
        function (error) {
          // if(error.response.status === 401){
          //   logOut();
          // }
          console.log("errore ricerca composizione " + error);
          // onSuccess(headerDataTableSanzione, user);
        }
      );
  }

  saveUserIsert(user, onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    let clienti = {
      idCliente: decoded.ID,
      attivo: 1,
      nome: "NordCom S.p.A",
      codiceFiscale: "13384100155",
      indirizzo: "Via Paleocapa, 7 20121 Milano (MI)",
      codiceUnivocoFatturazione: "",
      email: "info@nord-com.it",
    };
    user.clienti = clienti;
    // console.log(user);
    axios.post(host + "/api/v1/user/save", user, configHeaders).then(
      function (result) {
        // console.log(result.data);
        if (result.status === 401) {
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
        if (error.response.status === 401) {
          logOut();
        }
        console.log("errore ricerca composizione " + error);
        // onSuccess(headerDataTableSanzione, user);
      }
    );
  }
}
